import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Col, InputGroup } from 'react-bootstrap'
import ConnectedInput, {
  STORE_FORMAT_PERCENT,
  INPUT_TYPE_NUMBER
} from './ConnectedInput'
import * as formConstants from './form'

export const CONNECTED_INPUT_LABEL_KEY = 'label'

/**
 * This basic component is primarily responsible for styling and responsiveness
 * of number, percent and dollar amount inputs and their associated labels.
 * It uses the smart
 * ConnectedInput to allow the application to track state of the amounts the
 * user inputs. In place of a label, another connected input can be used
 * (via the labelInput prop) to allow the user to effectively input their own
 * label that will then be persisted in the redux store
 */
export default class FormattedConnectedInput extends Component {
  /**
   * Render the component
   * @returns
   */
  render () {
    let reduxKey = this.props.label
    if (this.props.reduxKey) {
      reduxKey = this.props.reduxKey
    }
    if (!reduxKey) {
      console.error(
        'FormattedConnectedInput requires either the "reduxKey" or "label" prop to persist values to the store.'
      )
    }

    let label
    if (this.props.labelInput) {
      label = (
        <Col xs={12} sm={3} className='inputAlign'>
          <ConnectedInput
            formControlStyle={formConstants.labelInputStyle}
            reduxKey={reduxKey + CONNECTED_INPUT_LABEL_KEY}
            type='text'
          />
        </Col>
      )
    } else if (this.props.wideLayout) {
      label = (
        <Col
          style={formConstants.labelStyle}
          xs={12}
          sm={3}
          md={4}
          className='inputAlign'
        >
          {this.props.label}
        </Col>
      )
    } else {
      label = (
        <Col
          style={formConstants.labelStyle}
          xs={12}
          sm={3}
          className='inputAlign'
        >
          {this.props.label}
        </Col>
      )
    }

    let inputGroup = <div />

    if (this.props.numberForm) {
      inputGroup = (
        <InputGroup style={formConstants.inputStyle}>
          <ConnectedInput reduxKey={reduxKey} type={INPUT_TYPE_NUMBER} />
        </InputGroup>
      )
    } else if (this.props.percentForm) {
      inputGroup = (
        <InputGroup style={formConstants.inputStyle}>
          <ConnectedInput
            reduxKey={reduxKey}
            type={INPUT_TYPE_NUMBER}
            storeFormat={STORE_FORMAT_PERCENT}
          />
          <InputGroup.Addon>%</InputGroup.Addon>
        </InputGroup>
      )
    } else if (this.props.dollarForm) {
      inputGroup = (
        <InputGroup style={formConstants.inputStyle}>
          <InputGroup.Addon>$</InputGroup.Addon>
          <ConnectedInput reduxKey={reduxKey} type={INPUT_TYPE_NUMBER} />
          <InputGroup.Addon>.00</InputGroup.Addon>
        </InputGroup>
      )
    } else {
      console.error(
        'FormattedConnectedInput requires one of numberForm, percentForm, or dollarForm be specified'
      )
    }

    let fg = <div />

    if (this.props.wideLayout) {
      fg = (
        <FormGroup>
          <Col xs={0} sm={1} lgHidden />
          {label}
          <Col xs={12} sm={7}>
            {inputGroup}
          </Col>
        </FormGroup>
      )
    } else {
      fg = (
        <FormGroup>
          <Col xs={0} sm={1} lgHidden />
          {label}
          <Col xs={12} sm={8} lg={9}>
            {inputGroup}
          </Col>
        </FormGroup>
      )
    }

    return fg
  }
}

FormattedConnectedInput.propTypes = {
  reduxKey: PropTypes.string,
  label: PropTypes.string,
  labelInput: PropTypes.bool,
  numberForm: PropTypes.bool,
  percentForm: PropTypes.bool,
  dollarForm: PropTypes.bool,
  wideLayout: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/forms/FormattedConnectedInput.js